import { NumberUtilities } from "../utilities/number-utilities";

export class NumberFormatHelper {

    public static getFormattedValue(value: number | string, culture: string = navigator.language, maximumFractionDigits: number = 2, fallBackValue: number = 0, startLabel: string = "", minimumFractionDigits: number = null): string {

        //make sure value is a number if defined
        if (typeof value == "string") {
            value = Number(value);
        }

        //make sure fallBackValue is a number if defined
        if (typeof fallBackValue == "string") {
            fallBackValue = Number(fallBackValue);
        }

        //default to navigator.language and then to uk if culture not provided
        if (!culture) {
            culture = navigator.language || "en-UK";
        }

        if (minimumFractionDigits == null || minimumFractionDigits < 0) minimumFractionDigits = (maximumFractionDigits ? maximumFractionDigits : 0);
        if (maximumFractionDigits == null) maximumFractionDigits = 15;

        const options = { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits };

        // apply fallback if value is not defined
        if (value == null || value == undefined) {
            value = fallBackValue;
        }

        let formattedNumber = "";
        let isNegative = false;
        if (value != null && value !== undefined) {

            value = NumberUtilities.round(value, maximumFractionDigits);

            isNegative = value < 0;
            formattedNumber = (isNegative ? -value : value).toLocaleString(culture, options);
        }

        if (formattedNumber) {
            return (isNegative ? "-" : "") + (startLabel || "") + formattedNumber;
        }

        return formattedNumber;
    }

}
